import { Navigate, Outlet, useLocation } from "react-router-dom";

function ProtectedRoute({ currentUser, loading }) {
  const location = useLocation();

  if (loading) {
    return <div className="p-4">Loading...</div>;
  }

  if (!currentUser) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  return <Outlet />;
}

export default ProtectedRoute;
